import React from "react"
import { store } from "react-notifications-component"
import ReactSVG from "react-svg"
import { NOTIFICATION_TYPE } from "../../constants/notification"

export default function CustomNotification(type = "", title = "", message = "", t = {}) {
  if (type) {
    store.addNotification(
      Object.assign({
        insert: "top",
        container: "top-right", //do not change container
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: false,
          showIcon: true
        },
        content: CustomContentRenderer
      })
    )
  }

  function CustomContentRenderer() {
    let icon
    let color
    if (type === NOTIFICATION_TYPE.DEFAULT || type === NOTIFICATION_TYPE.SUCCESS) {
      icon = "check_circle"
      color = type === NOTIFICATION_TYPE.DEFAULT ? "#5458F7" : "#84D65A"
    }
    if (type === NOTIFICATION_TYPE.DANGER) {
      icon = title === t("errorLabel") ? "exclamation_circle" : "delete_circle"
      color = "#EF665B"
    }
    const svgStyle = { width: 50, height: 50, color: color }
    return (
      <div className={`notification__custom--${type}`}>
        <div className="notification__custom-icon">
          <ReactSVG svgStyle={svgStyle} src={`images/${icon}.svg`} />
        </div>
        <div className="notification__custom">
          <div className="rnc__notification-close-mark"></div>
          <p className="rnc__notification-title">{title && title}</p>
          <p className="rnc__notification-message">{message}</p>
        </div>
      </div>
    )
  }
}
